import VillaDesignsSection from './VillaDesignsSection';

export default VillaDesignsSection;
